module.exports = __webpack_public_path__ + "static/img/8.f34cd8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/8.png
// module id = ouin
// module chunks = 0